import axios from "axios";
import config from "./config";

const instance = axios.create({
  baseURL: config.baseUrl,
  timeout: 50000,
});

export default instance;
